import { IFilterablePaginatedSection } from "@faire/web-api/indigofair/data/IFilterablePaginatedSection";

import { getNavigationTreeHashCode } from "@faire/retailer/serialized-data/getNavigationTreeHashCode";

export const useNavigationTreeQueryParams = (
  filterablePaginatedSection: IFilterablePaginatedSection
) => {
  const navigationTreeRequest =
    filterablePaginatedSection.get_s_d_u_i_navigation_tree_request;

  return {
    navigation_path: navigationTreeRequest?.navigation_path ?? "",
    navigation_tree_hash_code: getNavigationTreeHashCode(),
  };
};
